import React, { Fragment, Component } from 'react';
import NavBar from "../../components/common/forms/NavbarCopy";
import { AddNotification } from "../../components/Methods/Notificaition";
import {
  Row,
  Col,
  Container,
  Button,
  ButtonGroup,
  ButtonToolbar,
} from "react-bootstrap";
import { withSnackbar } from "notistack";
import { TfiLocationPin } from "react-icons/tfi";
import { MdOutlineArrowOutward } from "react-icons/md";
import { RiSearchLine } from "react-icons/ri";
import { BiCalendar, BiUserCircle, BiMap } from "react-icons/bi";
import { BsCalendarDate} from "react-icons/bs";
import { IoBoatOutline, IoLocationOutline, IoSearchOutline } from "react-icons/io5";
import { FaCrown } from "react-icons/fa"
import { AiOutlineCrown,AiOutlineInfoCircle } from "react-icons/ai"
import $ from "jquery";
import { Form } from "informed";
import { AutocompleteValue } from "../../components/common/forms/Autocomplete";
import moment from "moment";
import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";
import { Loader } from "../../components/common/forms/Loading";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { subDirectory } from "../../config.json";
import { getboattype } from '../../services/dropdownservice';
import axios from "axios";
import "./boat.scss";
import { getBoatHouseTiming } from "../../services/boatListService";
import { addDays, format, subHours, sub } from "date-fns";
import {BsFillInfoCircleFill} from "react-icons/bs"
import { CgCalendarDates } from 'react-icons/cg';
import { IoIosSearch } from 'react-icons/io';
// import videoFile from "../../images/Boatbg.mp4"

import videoFile from "../../images/Publicloginbg.mp4"

const dateFormat = "YYYY/MM/DD";
// const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY'];
class BoatSearch extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openNotification: false,
      menuIsOpen: false,
      menuIsOpen1: false,
      datepick: false,
      BoatHType: [],
      BoatHouseName: "",
      BoatHouseId: "",
      BoatStatusId: "N",
      BoatStatusName: "Normal",
      BoatStatus: [{ ConfigId: "N", ConfigName: "Normal" },
      { ConfigId: "P", ConfigName: "Express" }],
      CheckedDate: new Date(),
      SelectedClassType: "",
      MinDate: new Date(),
      isBoatHouseName: false,
      isClassName: false,
      isDatePick: false,
      warning:false,
      iscoutrallam:false,
      BoatingType:"Y"
      // CheckedDate: moment(new Date(), dateFormat),
      // CheckedDate: moment().format("DD/MM/YYYY"),
      // CheckedDate:{moment(new Date(), dateFormatList[0])} format={dateFormatList}
    }
  }

  openBoatHouseName = async () => {
    await this.setState((prevState) => ({
      isBoatHouseName: !prevState.isBoatHouseName,
    }));
    if (this.state.isBoatHouseName) {
      await this.setState({ isClassName: false, isDatePick: false });
    }
    this.forceUpdate();
  };
  openBoatClassName = async () => {
    await this.setState((prevState) => ({
      isClassName: !prevState.isClassName,
    }));

    if (this.state.isClassName) {
      await this.setState({ isBoatHouseName: false, isDatePick: false });
    }
    this.forceUpdate();
  };
  datePicker = async () => {
    await this.setState((prevState) => ({
      isDatePick: !prevState.isDatePick,
    }));
    if (this.state.isDatePick) {
      await this.setState({ isBoatHouseName: false, isClassName: false });
    }
    this.forceUpdate();
  };
  componentDidMount = async () => {
    await this.getboattype();


  }
  getBoatHouseTimingData = async (boathouseid) => {
    let data = {
      BoatHouseId: boathouseid,
    };
    const res = await getBoatHouseTiming(data);
    let boatcloseTime = res.data.Response[0].BookingTo;
    let ClosingBeforeTime = res.data.Response[0].ClosingBeforeTime;
    // (YYYY-MM-DD)
    let todayTime = format(new Date(), "HH:mm:ss");
    let todayDate = format(new Date(), "MM/dd/yyyy");

    let closetime = ClosingBeforeTime.split(`:`);

    let closeDateTime = sub(new Date(todayDate + " " + boatcloseTime), { hours: closetime[0], minutes: closetime[1], seconds: closetime[2] });
    // moment(Date.now()).subtract({days:3, hours:5});
   
    // if (new Date(todayDate + " " + boatcloseTime) < new Date())
 
    if (closeDateTime < new Date()) {
      // new Date(todayDate + " " + todayTime) > new Date(todayDate + " " + boatcloseTime)
      // let mindate = addDays(new Date(), 1);
      let mindate = addDays(new Date(), 1);
      await this.setState({ boatClosed: true, MinDate: mindate });
 
     
      if (new Date(format(this.state.MinDate, "MM/dd/yyyy") + " " + "00:00:00") > new Date(format(this.state.CheckedDate, "MM/dd/yyyy") + " " + "00:00:00")) {
       
        await this.setState({ loading: false, CheckedDate: mindate,warning:true });

        // await this.setState({
        //   openNotification: true,
        //   message: "Sorry, Boat Booking Time is Ended Today !!!",
        //   variant: "error",
        // });
      }
    } else {
      await this.setState({ boatClosed: false, MinDate: new Date() });
    }
  };
  getboattype = async () => {
    const res = await getboattype();

    if (res.data.StatusCode === 1) {
      this.setState({ BoatHType: res.data.Response });

    } else {

      this.setState({ BoatHType: [] });
    }

  }


  handleChangeBoat = async (name, e) => {

    let boathouse = e.BoatHouseName
    await this.setState({
      BoatHouseName: e.BoatHouseName,
      BoatHouseId: e.BoatHouseId,
      SelectedClassType:e.ClassType,
      BoatingType:e.BoatingType
    });
    this.getBoatHouseTimingData(e.BoatHouseId);
    if(boathouse ==="Courtallam Boat House"){
      this.setState({iscoutrallam :true})
    }
  };

  handleChangeStatus = async (name, e) => {

    await this.setState({
      BoatStatusName: e.ConfigName,
      BoatStatusId: e.ConfigId
    });
  };

  handleDateChange = async (date) => {
    await this.setState({
      CheckedDate: date,
    });

    this.setState({ isDatePick: !this.state.isDatePick })
    if(this.state.SelectedClassType ==="S"){
      this.BoatSearch()
    }
  };
  BoatSearch = async () => {

    if ((this.state.BoatHouseName === "" || this.state.BoatStatusName === "" || this.state.CheckedDate === "")) {
      this.setState({
        openNotification: true,
        message: "Please select a boat house",
        variant: "warning",
      });
    }
    else {
      this.props.history.push({
        pathname: `${subDirectory}/boat-list`,
        state: {
          BoatHouseId: this.state.BoatHouseId,
          BoatHouseName: this.state.BoatHouseName,
          TripDate: this.state.CheckedDate,
          ClassTypeId: this.state.BoatStatusId,
          ClassTypeName: this.state.BoatStatusName,
          SelectedClassType: this.state.SelectedClassType,
          BoatingType:this.state.BoatingType
        },

      })
    }

  }


  render() {

    const { menuIsOpen, menuIsOpen1, CheckedDate, datepick, BoatHType, BoatStatus } = this.state
 

    return (
      <Fragment>
        <AddNotification
          visible={this.state.openNotification}
          variant={this.state.variant}
          message={this.state.message}
          onClose={() => this.setState({ openNotification: false })}
        />
        <div class="boatContainer" id="boatContainer" style={{ fontfamily: "Inter, sans-serif !important"}}>
        <div style={{position:"fixed", zIndex:"-1"}}  className="video-background">
              <video width="auto" height="auto"   autoPlay loop muted playsInline>
                <source src={videoFile} type="video/mp4" /> 
              </video>
            </div>
          <NavBar {...this.props} />



       

          <Container fluid className="hotelbody">
            <Loader fullPage loading={this.state.loading} />
            <Form
              getApi={this.setFormApi}
              onSubmit={this.onSubmit}
              className=""
            >
              {({ formApi, formState }) => (
                <div>
                  <div className="d-flex px-3 pt-3 justify-content-start  ">
                    {/* <div className="img-wrapper">
                      <div class="media-mob">
                        <div class="section">
                          <div class="ex-hotels"></div>
                        </div>
                        <div class="cursor" id="cursor"></div>
                        <div class="cursor2" id="cursor2"></div>
                        <div class="cursor3" id="cursor3"></div>
                      </div>
                    </div> */}

                      <div className='ttdc-bg-img'>

 

                            
                        <div >

                          <div className="hotel-list" style={{letterSpacing:"0px"}}>

                            <div class="search_hotels_header  ">
                              
                                <div style={{fontSize:'clamp(21px, 7vw,39px)', color:'#000', fontWeight:'600', textTransform:'captalize'}}>Pick Your Boat Ride</div>
                                <div style={{fontSize:'clamp(11px, 2.2vw, 13px)',  color:'#000', fontWeight:'400'}}>Come aboard Pick Your Boat Ride for an amazing adventure!</div> 
                                <div style={{fontSize:'clamp(11px, 2.2vw, 13px)',  color:'#000', fontWeight:'400'}}>Each wave brings excitement and fun!</div>
                            </div>



                            <div  style={{display:'flex',  margin:'0rem 0rem', color:'#000', columnGap:'2rem', fontSize:"clamp(7px, 2.5vw, 12px)", fontWeight:'600',textTransform:"uppercase"}}> 
                              <div>  <IoBoatOutline /> 10+ Boat Houses </div>
                              <div> <IoLocationOutline  />  8+ Locations </div>
                            </div>


                        <div style={{display:'flex', flexDirection:'row',flexWrap:'wrap', }}>
                            <div className="hotel-search" onClick={this.openBoatHouseName}>

                              <div className="hotel-wrapper">

                                 <div style={{fontSize:'14px',color:"#198754"}} >
                                 <TfiLocationPin /> <label >Boat House</label>
                                </div>
                                 
                                <AutocompleteValue
                                  menuIsOpen={this.state.isBoatHouseName}
                                  field="BoatHouseName"
                                  className="boatselection"
                                  name="name"
                                  placeholder={"Select"}
                                  getOptionValue={(option) => option.BoatHouseId}
                                  getOptionLabel={(option) => option.BoatHouseName}
                                  options={BoatHType}
                                  value={BoatHType}
                                  // placeholder={""}
                                  onChange={(e) =>
                                    this.handleChangeBoat("name", e)
                                  }
                                  autoComplete="off"
                                  required
                                />

                                
                              </div>

                            </div>

                            <div className="hotel-search"
                            onClick={() => {
                                          return this.state.isDatePick == false ? this.setState({ isDatePick: true, isBoatHouseName: false, isClassName: false }) : null;
                                        }}>
                              <div className="hotel-wrapper">

                              <div style={{fontSize:'14px',color:"#198754" }}  > 
                               
                              <CgCalendarDates /> <label >Boat Trip Date</label>
                            </div> 


                                <div
                                  style={{ marginLeft: "-2px", marginTop: "-4px" }}
                                >
                                  <DatePicker
                                    dateFormat="eee, dd/MM/yyyy"
                                    field="CheckedDate"
                                    selected={CheckedDate}
                                    onChange={this.handleDateChange}
                                    className="CheckedDate"
                                    placeholder={this.state.CheckedDate}
                                    // open={datepick}
                                    open={this.state.isDatePick}
                                    // minDate={new Date()}
                                    minDate={new Date(this.state.MinDate)}
                                  />
                                  


                                </div>
                               
                              </div>

                            </div>
                        </div>

                            {/* {this.state.SelectedClassType === "M" &&
                            <>
                              <Row className="hotel-search" onClick={this.openBoatClassName}>
                                <div
                                  className="hotel-wrapper"
                                  // onClick={this.showPersons}
                                >
                                  <div class="hotelelements" >
                                    <label class="labelcolor bb">CLASS</label>
                                    <br />
                                    <AutocompleteValue
                                      menuIsOpen={this.state.isClassName}
                                      field="StatusName"
                                      name="name"
                                      getOptionValue={(option) => option.ConfigID}
                                      getOptionLabel={(option) => option.ConfigName}
                                      options={BoatStatus}
                                      value={BoatStatus}
                                      placeholder={"Normal"}
                                      onChange={(e) =>
                                        this.handleChangeStatus("name", e)
                                      }
                                      autoComplete="off"
                                      required
                                    />

                                  </div>
                                  <div class="hotelicon" >
                                    <AiOutlineCrown size="25px" />
                                  </div>
                                </div>
                                
                              </Row>
                              <div className="mt-1 ml-2 classdiv">
                            
                              <div className=" d-flex "> < BsFillInfoCircleFill size={10} className="mr-2 mt-1" /> Normal – <i className="i-font">Regular Queue Wait Time Applicable</i></div>
                              <div className="d-flex expressdiv">  < BsFillInfoCircleFill size={10} className="mr-2 mt-1"  /><div className="bblink-express">Express</div> – <i className="i-font"> Lesser Wait Time, Faster Process</i></div>
                              </div>

    </>
                            } */}
 
                            
                            <div  style={{display:'flex', justifyContent:'flex-end'}}>
                              <Button type="submit" className="animated-button" onClick={this.BoatSearch}>
                                  <MdOutlineArrowOutward className='arr-2'/>
                                  <span className="text">Search</span>
                                  <RiSearchLine  className='arr-1'/> 
                              </Button> 

                            </div>

                            {this.state.warning === true && <div className="mt-4 d-flex war-div "> 
                            <div>Boat house booking time is over for today, you can book from tomorrow.</div>
                            </div>}

                            {this.state.iscoutrallam === true && <div className="mt-4 d-flex coutrallam-div "> < BsFillInfoCircleFill size={20} /> 
                            <div> Boating Service in Courtallam is available only during June, July, August and depending upon the sufficient water availability.</div>
                            </div> }
                          
                          </div>
                        </div>
                        

                      </div>

 

                    
                  </div>
                </div>
              )}
            </Form>
          </Container>
        </div>
      </Fragment>
    )
  }
}


export default withSnackbar(BoatSearch);

